<template>
  <el-select
    :value="value"
    filterable
    allow-create
    default-first-option
    @change="handleChange"
    placeholder="请选择或输入后新建"
  >
    <el-option
      v-for="(item, index) in options"
      :key="index"
      :label="item"
      :value="item"
    >
    </el-option>
  </el-select>
</template>

<script>
import { wikiList } from '@/service/getData'
export default {
  props: {
    value: '',
  },
  data() {
    return {
      options: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async getData() {
      let res = await wikiList({
        tag_options: true,
      })
      if (res.code == 0) {
        this.options = res.data.list
      }
    },
  },
}
</script>